export enum EngineTab {
  DefaultSetpoints = 'defaultSetpoints',
  CompressorGroups = 'compressorGroups',
  FallbackScenarios = 'fallbackScenarios',
  SensorsConfiguration = 'sensorsConfiguration',
  MainRangesConfiguration = 'mainRangesConfiguration',
  DefaultSetpointsConfiguration = 'defaultSetpointsConfiguration',
  StationConfiguration = 'stationConfiguration',
  CompressorParameters = 'compressorParameters',
  General = 'general',
}
